module.exports = __webpack_public_path__ + "static/media/logo192-bankapi.fbbf8dbc.png";